import type { RegisteredServices } from '@/core/container/types'

export const ticketSaveViewAsFormId = 'TicketSaveAsModalFormService' as const satisfies RegisteredServices
export const ticketSaveViewAsModalId = 'ticketSaveViewAsModal' as const
export const ticketFilteredViewPreviewModalId = 'TicketFilteredViewPreviewModal' as const
